"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * A hook that tracks the previous value of a given variable.
 * @template T
 * @param {T} value - the value to be tracked
 * @returns {T} the previous value
 */
const usePrevious = (value) => {
    const ref = react_1.default.useRef();
    react_1.default.useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};
exports.default = usePrevious;
//# sourceMappingURL=usePrevious.js.map